import React, { useState } from 'react';
import { MessageCircle, Phone, Send, X } from 'lucide-react';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([
    {
      id: 1,
      text: "Hi! Welcome to Kanactify! 👋 We're excited to help you transform your digital presence. If you need any assistance or want to discuss your project, feel free to give us a call at +91 9021076873. Our team is here to make your vision come to life!",
      sender: 'bot',
      timestamp: new Date()
    }
  ]);

  const handleSendMessage = () => {
    if (message.trim()) {
      const newMessage = {
        id: messages.length + 1,
        text: message,
        sender: 'user',
        timestamp: new Date()
      };
      
      setMessages([...messages, newMessage]);
      setMessage('');
      
      // Auto-reply after user message
      setTimeout(() => {
        const botReply = {
          id: messages.length + 2,
          text: "Thanks for your message! For immediate assistance, please call us at +91 9021076873 or use our contact form. We'll get back to you shortly! 😊",
          sender: 'bot',
          timestamp: new Date()
        };
        setMessages(prev => [...prev, botReply]);
      }, 1000);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const callNow = () => {
    window.open('tel:+919021076873', '_self');
  };

  return (
    <>
      <div className="fixed right-4 bottom-4 z-50">
        {/* Chat Window */}
        {isOpen && (
          <div className="mb-4 w-80 h-96 bg-white rounded-2xl shadow-2xl border border-gray-200 flex flex-col overflow-hidden animate-slideUp">
            {/* Header */}
            <div className="bg-gradient-to-r from-violet-500 to-indigo-500 text-white p-4 flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                  <MessageCircle size={16} />
                </div>
                <div>
                  <h3 className="font-semibold text-sm">Kanactify Support</h3>
                  <p className="text-xs text-white/80">Online now</p>
                </div>
              </div>
              <button
                onClick={() => setIsOpen(false)}
                className="text-white/80 hover:text-white p-1"
              >
                <X size={16} />
              </button>
            </div>

            {/* Messages */}
            <div className="flex-1 p-4 overflow-y-auto space-y-3 bg-gray-50">
              {messages.map((msg) => (
                <div
                  key={msg.id}
                  className={`flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`}
                >
                  <div
                    className={`max-w-xs p-3 rounded-2xl text-sm ${
                      msg.sender === 'user'
                        ? 'bg-violet-500 text-white rounded-br-md'
                        : 'bg-white text-gray-800 rounded-bl-md shadow-sm border'
                    }`}
                  >
                    {msg.text}
                  </div>
                </div>
              ))}
            </div>

            {/* Input Area */}
            <div className="p-4 border-t border-gray-200 bg-white">
              <div className="flex space-x-2">
                <input
                  type="text"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  onKeyPress={handleKeyPress}
                  placeholder="Type your message..."
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-transparent"
                />
                <button
                  onClick={handleSendMessage}
                  className="bg-violet-500 hover:bg-violet-600 text-white p-2 rounded-full transition-colors duration-200"
                >
                  <Send size={16} />
                </button>
              </div>
              
              {/* Quick Call Button */}
              <button
                onClick={callNow}
                className="w-full mt-3 bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white py-2 px-4 rounded-full text-sm font-medium transition-all duration-200 flex items-center justify-center space-x-2"
              >
                <Phone size={14} />
                <span>Call Now: +91 9021076873</span>
              </button>
            </div>
          </div>
        )}

        {/* Chat Toggle Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="group bg-gradient-to-r from-violet-500 to-indigo-500 hover:from-violet-600 hover:to-indigo-600 text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-110 relative"
        >
          {isOpen ? <X size={24} /> : <MessageCircle size={24} />}
          
          {/* Notification Dot */}
          {!isOpen && (
            <div className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
          )}
          
          {/* Floating Message Preview */}
          {!isOpen && (
            <div className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-white text-gray-800 px-3 py-2 rounded-lg shadow-lg text-sm max-w-xs opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
              Need help? Chat with us! 💬
            </div>
          )}
        </button>
      </div>

      {/* Styles */}
      <style jsx>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-slideUp {
          animation: slideUp 0.3s ease-out;
        }
      `}</style>
    </>
  );
};

export default Chatbot;